import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO32 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK003-2.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO32
